import { IconsProps } from '@/types/shared'
import React from 'react'

const FeatureIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 100 100"
                fill="none"
                className="w-full h-full drop-shadow-lg"
            >
                <path
                    d="M50 15C42 15 35 22 35 30C32 30 29 33 29 36C29 39 32 42 35 42C35 50 42 57 50 57C58 57 65 50 65 42C68 42 71 39 71 36C71 33 68 30 65 30C65 22 58 15 50 15Z"
                    fill="#4CAF50"
                    opacity="0.8"
                />
                <path
                    d="M40 25C40 25 45 30 50 25C55 30 60 25 60 25"
                    stroke="#2E7D32"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                />
                <path
                    d="M38 35C38 35 42 38 46 35C50 38 54 35 54 35"
                    stroke="#2E7D32"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                />
                <g fill="#4CAF50">
                    <rect x="25" y="12" width="1.5" height="6" rx="0.75" />
                    <rect x="22" y="15" width="6" height="1.5" rx="0.75" />
                    <rect x="72" y="20" width="1.5" height="6" rx="0.75" />
                    <rect x="69" y="23" width="6" height="1.5" rx="0.75" />
                </g>
            </svg>
        </div>
    )
}

export default FeatureIcons
